import notes from './notes';
import modalReason from './modalReason';
import recurringInput from './recurringInput';
import modalChangePassword from './modalChangePassword';
import modal from './modal';
import modalCreateNote from './modalCreateNote';
import button from './button';
import form from './form';
import creditCardManagement from './creditCardManagement';
import table from './table';
import toast from './toast';
import dragDropFile from './dragDropFile';
import mServerTable from './m-server-table';
import selectTableSplit from './select-table-split';

const views = {
  notes,
  modalReason,
  recurringInput,
  modalChangePassword,
  modal,
  modalCreateNote,
  button,
  form,
  creditCardManagement,
  table,
  toast,
  dragDropFile,
  mServerTable,
  selectTableSplit,
};

export default views;
